/**
 * @param {string|null|undefined} school_district_code
 * @returns {string}
 */
function schoolDistrictCodeLabel(school_district_code) {
  const raw = school_district_code;
  return raw != null && String(raw).trim() !== '' ? String(raw).trim() : 'NA';
}

/**
 * Human-readable milestone label for dashboard / referral tracking tables.
 * School and TPC rows show the client's school district short code (school_districts.district), not the stored milestone_name.
 * Exit is labeled "Exit start" (single due point, not a window end).
 *
 * @param {{ milestone_type?: string, milestone_name?: string|null, school_district_code?: string|null }} row
 * @returns {string}
 */
export function formatTrackingMilestoneDisplayName(row) {
  if (!row) return '';
  if (row.milestone_type === 'SCHOOL') {
    return `School (${schoolDistrictCodeLabel(row.school_district_code)})`;
  }
  if (row.milestone_type === 'TPC') {
    return `TPC (${schoolDistrictCodeLabel(row.school_district_code)})`;
  }
  if (row.milestone_type === 'EXIT') {
    return 'Exit start';
  }
  return row.milestone_name || '';
}
